export default "__VITE_ASSET__CvfwKZ5S__"